import { useEffect, useState, useCallback } from "react";

/**
 * Persistent light/dark theme toggle. Adds/removes `.theme-light` on <html>.
 * Defaults to dark (PROGÈRE brand default).
 */
const KEY = "progere_theme";

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem(KEY) || "dark"; } catch { return "dark"; }
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "light") root.classList.add("theme-light");
    else root.classList.remove("theme-light");
    // Also set the universal `data-theme` attribute used by the shared
    // PROGÈRE theme (dark/light) — see /src/styles/progere-theme.css
    root.setAttribute("data-theme", theme);
    try { localStorage.setItem(KEY, theme); localStorage.setItem("progere-theme", theme); } catch {/* ignore */}
  }, [theme]);

  const toggle = useCallback(() => setTheme((t) => (t === "dark" ? "light" : "dark")), []);
  return { theme, toggle, setTheme };
}
